<template>
  <div :_uid="_uid">
  </div>
</template>

<script>
export default {
  props: [
    'value',
  ],
  data() {
    return {
      is_enabled_to_show: 0,
    }
  },
  mounted() {
    var elements = payjp.elements()
    var cardElement = elements.create('card')
    cardElement.mount('[_uid="'+this._uid+'"]')

//    let scriptOnCreated = document.createElement('script')
//    scriptOnCreated.text = `function onCreatedPayjp_${this._uid}(e) { console.log(e); }`
//    this.$el.appendChild(scriptOnCreated)
//
//    let scriptOnFailed = document.createElement('script')
//    scriptOnFailed.text = `function onFailedPayjp_${this._uid}(e) { console.log(e); }`
//    this.$el.appendChild(scriptOnFailed)
//
//    setTimeout(() => {
//    let scriptButton = document.createElement('script')
//    scriptButton.setAttribute('src', 'https://checkout.pay.jp')
//    scriptButton.setAttribute('class', 'payjp-button')
//    scriptButton.setAttribute('data-key', 'pk_test_ab4fc9ec7dc61035eef18245')
//    scriptButton.setAttribute('data-on-created', 'onCreatedPayjp_' + this._uid)
//    scriptButton.setAttribute('data-on-failed', 'onFailedPayjp_' + this._uid)
//    scriptButton.setAttribute('data-partial', true)
//    scriptButton.async = true
//    this.$el.appendChild(scriptButton)
//    }, 10)
//
//    // script.defer = tru
//    // document.head.appendChild(script)
  },
}
</script>

<style lang="scss">
</style>
